import Vue from 'vue'
import Router from 'vue-router';
import { MessageBox } from 'element-ui';
import store from '@/store/index.js';
import Message from '@/script/Message';
import Front from './front/index';
import Admin from './admin/index';

Vue.use(Router)

const { isNavigationFailure, NavigationFailureType } = Router

/** 重复跳转、被新导航打断、守卫 abort 等属正常情况，不应 Uncaught */
function isIgnorableNavigationFailure(err) {
	return (
		isNavigationFailure(err, NavigationFailureType.duplicated) ||
		isNavigationFailure(err, NavigationFailureType.cancelled) ||
		isNavigationFailure(err, NavigationFailureType.aborted)
	)
}

function patchRouterMethod(methodName) {
	const original = Router.prototype[methodName]
	Router.prototype[methodName] = function patched(location, onResolve, onReject) {
		if (onResolve || onReject) {
			return original.call(this, location, onResolve, onReject)
		}
		return original.call(this, location).catch((err) => {
			if (isIgnorableNavigationFailure(err)) {
				return err
			}
			return Promise.reject(err)
		})
	}
}

patchRouterMethod('push')
patchRouterMethod('replace')

let defaultRouter = [
	{
		path: '/',
		redirect: '/front/login'
	}
];
let mrouter = defaultRouter.concat(Front, Admin);
var router = new Router({
	mode: "history",
	mode: process.env.MODE,
	routes: mrouter
});

/** 发版后旧缓存 chunk 与入口不匹配时，按需加载会失败；空闲时提示刷新，任务进行中不刷新以免清掉 Vuex */
const CHUNK_RELOAD_TS_KEY = '__chunk_reload_ts'
const CHUNK_NOTICE_COOLDOWN_MS = 8000

/** readConfig / copyConfig：与 startReadProduct 一致，7 为 node 已停视为可刷新 */
function isConfigStateBusy(stateVal) {
	return stateVal === 1 || stateVal === 2 || stateVal === 3 || stateVal === 5 || stateVal === 6
}

function isPublishConfigBusy(cfg) {
	if (!cfg) return false
	return isConfigStateBusy(cfg.STATE) || isConfigStateBusy(cfg.PDDSTATE)
}

function isTaskStateBusy(val) {
	return val === 1 || val === 2 || val === 3
}

function isProductTaskRunning() {
	const p = store.state.product
	if (!p) return false
	if (p.loading || p.imageUploadLockDepth > 0) return true
	if (isPublishConfigBusy(p.readConfig)) return true
	if (isPublishConfigBusy(p.copyConfig)) return true
	if (isTaskStateBusy(p.banJiaStatus)) return true
	if (p.flashsale_load_running) return true

	const taskStateKeys = [
		'shangjistate', 'titlestate', 'shorttitlestate', 'brandstate', 'aftersalestate',
		'attrstate', 'fabricstate', 'freightstate', 'flashsalestate', 'offlineDeleteState',
		'draftsWebReleaseState', 'draftsSyncState', 'violationBatchSyncState', 'deadStockAnalyzeState', 'deadStockBatchState', 'lowQualityFetchState', 'lowQualityBatchState', 'qualityDiagnoseFetchState', 'qualityDiagnoseBatchState',
	]
	return taskStateKeys.some((key) => isTaskStateBusy(p[key]))
}

function isChunkLoadError(error) {
	const message = (error && error.message) || String(error)
	return (
		(error && error.name === 'ChunkLoadError') ||
		/Loading chunk [\w-]+ failed/i.test(message) ||
		/Loading CSS chunk [\w-]+ failed/i.test(message) ||
		/Failed to fetch dynamically imported module/i.test(message)
	)
}

function shouldThrottleNotice(key) {
	const now = Date.now()
	const last = Number(sessionStorage.getItem(key) || 0)
	if (now - last < CHUNK_NOTICE_COOLDOWN_MS) {
		return true
	}
	sessionStorage.setItem(key, String(now))
	return false
}

let chunkReloadPromptOpen = false

router.onError((error) => {
	console.log('router 出现异常1',error);
	if (!isChunkLoadError(error)) {
		return
	}

	if (isProductTaskRunning()) {
		if (!shouldThrottleNotice('__chunk_running_warn_ts')) {
			Message.warning({
				message: '检测到前端资源已更新。当前有任务进行中，请继续完成后再刷新页面，以免丢失链接和进度。',
				duration: 6000,
			})
		}
		return
	}

	if (chunkReloadPromptOpen || shouldThrottleNotice('__chunk_reload_prompt_ts')) {
		return
	}

	chunkReloadPromptOpen = true
	MessageBox.confirm(
		'检测到前端资源已更新，需要刷新页面才能正常打开新菜单。当前无进行中的任务，是否立即刷新？',
		'版本资源更新',
		{
			confirmButtonText: '立即刷新',
			cancelButtonText: '稍后再说',
			type: 'warning',
		}
	).then(() => {
		sessionStorage.setItem(CHUNK_RELOAD_TS_KEY, String(Date.now()))
		window.location.reload()
	}).catch((e) => {
		console.log('router 出现异常2',e);
	}).finally(() => {
		chunkReloadPromptOpen = false
	})
})

router.beforeEach((to, from, next) => {
	next();
});
export default router;
